import ComponentManager, {
	ComponentOptions,
	ComponentOptionsInterface,
	ComponentOptionsValuePlaceholder
} from "../../../componentFramework";
import EventListenerManager from "../../EventListenerManager";
import InlineMenuManager from "../InlineMenuManager";
import eventListenerOption from "../../../scripts/eventListenerOption";

const defaultOptions = {
	styleClass: {
		isOpen: "inlineMenuControl--isOpen",
	},
	menuId: ComponentOptionsValuePlaceholder.string.required
};
export type DefaultOptionsType = typeof defaultOptions;

@ComponentManager.register()
export default class InlineMenuControl<InstanceOptions extends ComponentOptionsInterface = ComponentOptionsInterface> {
	public static componentStyleClass = "inlineMenuControl";

	private readonly options: ComponentOptions<DefaultOptionsType & InstanceOptions>;
	private readonly eventListenerManager = new EventListenerManager();

	constructor(private readonly rootElement: HTMLElement, instanceOptions?: InstanceOptions) {
		this.options = new ComponentOptions(this, rootElement, defaultOptions).extend(instanceOptions);

		this.eventListenerManager.manage(rootElement).addEventListener("click", event => {
			if (this.isOpen()) {
				this.close();
			} else {
				this.open();
			}
			event.stopPropagation();
		}, eventListenerOption.passiveNotCapture);

		InlineMenuManager.getInstance().registerControl(this, this.doOpen, this.doClose);
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		InlineMenuManager.getInstance().unregisterControl(this);
		this.eventListenerManager.removeListeners();
	}

	public getMenuId(): string {
		return this.options.getValues().menuId;
	}

	public isOpen() {
		return this.rootElement.classList.contains(this.options.getValues().styleClass.isOpen);
	}
	public open() {
		InlineMenuManager.getInstance().open(this);
	}
	public close() {
		InlineMenuManager.getInstance().close(this.getMenuId());
	}
	private doOpen() {
		this.rootElement.classList.add(this.options.getValues().styleClass.isOpen);
	}
	private doClose() {
		this.rootElement.classList.remove(this.options.getValues().styleClass.isOpen);
	}

	public getBoundingClientRect(): DOMRect {
		return this.rootElement.getBoundingClientRect();
	}

	public getRootElement() {
		return this.rootElement;
	}
}
